import React from 'react';

import { blockingColors } from 'design-system/tokens';
import { RCR_CONTACT_PHONES } from 'pages/BusinessContact/contactsConfig';
import { buildTelHref } from 'utils/buildContactLinks';

import { PENDENCIAS_TEXTS } from '../constants';
import {
  CallCenterRow,
  ContactLine,
  ContactList,
  HeadsetCircle,
  ModalSubtitle,
  PhoneIconLink,
} from './styles';

const HeadsetIcon = (): JSX.Element => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M4 13v-1a8 8 0 1 1 16 0v1"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
    />
    <rect
      x="2.5"
      y="12.5"
      width="4"
      height="6"
      rx="1.6"
      stroke="currentColor"
      strokeWidth="1.6"
    />
    <rect
      x="17.5"
      y="12.5"
      width="4"
      height="6"
      rx="1.6"
      stroke="currentColor"
      strokeWidth="1.6"
    />
    <path
      d="M19.5 18.5v1a2.5 2.5 0 0 1-2.5 2.5h-2"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
    />
  </svg>
);

const PhoneIcon = (): JSX.Element => (
  <svg viewBox="0 0 16 16" fill="none" aria-hidden="true">
    <path
      d="M4.2 2.5 6 2l1.2 2.8-1.4 1c.6 1.3 1.6 2.3 2.9 2.9l1-1.4L12.5 8.5 12 10.3c-.2.7-.9 1.1-1.6 1C6.6 10.8 3.4 7.6 3 3.9c-.1-.6.4-1.3 1.2-1.4z"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinejoin="round"
    />
  </svg>
);

const CallCenterContent = (): JSX.Element => (
  <CallCenterRow>
    <HeadsetCircle aria-hidden="true">
      <HeadsetIcon />
    </HeadsetCircle>

    <ContactList>
      <ModalSubtitle>
        {PENDENCIAS_TEXTS.MODAL_CALL_CENTER_SUBTITLE}
      </ModalSubtitle>

      {RCR_CONTACT_PHONES.map((contact) => (
        <ContactLine key={contact.tel}>
          <span>{`${contact.display} ${contact.hint ?? ''}`.trim()}</span>
          <PhoneIconLink
            href={buildTelHref(contact.tel)}
            aria-label={`Ligar para ${contact.display}`}
            style={{ color: blockingColors.actionBlue }}
          >
            <PhoneIcon />
          </PhoneIconLink>
        </ContactLine>
      ))}
    </ContactList>
  </CallCenterRow>
);

export default CallCenterContent;
